import React from 'react';
import PropTypes from 'prop-types';
import MoreHoriz from '@mui/icons-material/MoreHoriz';
import i18n from 'i18next';

import { Button } from 'uikit/buttons';
import { Menu } from 'uikit/menus';

import { getMenuItems } from '@/exceed';

import styles from '../styles/learningObjectivesListItemKebabMenu.module.scss';

const LearningObjectivesListItemKebabMenu = ({
  item,
  onKebabMenuItemClick,
  isKebabDisabled = false,
}) => {
  const {
    data: { isDisplayed },
    hasChildren,
  } = item;

  if (isKebabDisabled) return null;

  const options = hasChildren
    ? getMenuItems([
        !isDisplayed
          ? {
              icon: 'visible',
              key: 'learning-objectives.show',
              onClick: () => {
                onKebabMenuItemClick({ action: 'show' });
              },
            }
          : {
              icon: 'invisible',
              key: 'learning-objectives.hide',
              onClick: () => {
                onKebabMenuItemClick({ action: 'hide' });
              },
            },
      ])
    : getMenuItems([
        {
          icon: 'edit',
          key: 'edit',
          onClick: () => {
            onKebabMenuItemClick({ action: 'edit', item });
          },
        },
        {
          icon: 'delete',
          key: 'delete',
          onClick: () => {
            onKebabMenuItemClick({ action: 'delete', item });
          },
        },
      ]);

  return (
    <Menu
      className={styles.element}
      shouldAnimate={false}
      testId={`learning-objectives-list-item-kebab-${item.id}`}
      component={
        <Button
          size="xsmall"
          variant="ghost"
          icon={<MoreHoriz />}
          aria-label={i18n.t('learning-objectives.toggle-options-menu')}
        />
      }
    >
      {options}
    </Menu>
  );
};

LearningObjectivesListItemKebabMenu.propTypes = {
  isKebabDisabled: PropTypes.bool,
  item: PropTypes.shape({
    hasChildren: PropTypes.bool,
    data: PropTypes.shape({
      isDisplayed: PropTypes.bool,
    }).isRequired,
  }).isRequired,
  onKebabMenuItemClick: PropTypes.func.isRequired,
};

export default React.memo(LearningObjectivesListItemKebabMenu);
